/** Sing in My Voice + Re-do a Section (owner session cookie). */
import axios from "axios";
import { API } from "@/lib/creatorApi";
import { chunkedUpload } from "@/lib/chunkedUpload";

const http = axios.create({ baseURL: API, withCredentials: true });
const data = (p) => p.then((r) => r.data);

export const VOICE_SONG_ACTIVE = ["preparing", "separating", "converting", "mixing", "saving"];
export const VOICE_SONG_PHASE = {
  queued: "Getting ready", separating: "Splitting the vocals from the music", converting: "Singing every vocal in your voice",
  mixing: "Putting your voice back with the music", saving: "Saving the new song",
};

export const singSong = (body) => data(http.post("/voice-songs", body));
export const listVoiceSongs = (songId) => data(http.get("/voice-songs", { params: songId ? { song_id: songId } : {} }));
export const deleteVoiceSong = (id) => data(http.delete(`/voice-songs/${id}`));
export const retryVoiceSong = (id) => data(http.post(`/voice-songs/${id}/retry`));
export const uploadVoiceSong = (file, { title, voice_id, pitch }, onProgress) => chunkedUpload(http, {
  start: "/voice-songs/uploads", chunk: (id, i) => `/voice-songs/uploads/${id}/chunks/${i}`, finish: (id) => `/voice-songs/uploads/${id}/finish`,
}, file, { filename: file.name, size: file.size, title: title || null, voice_id, pitch }, {}, onProgress);

export const redoSection = (body) => data(http.post("/song-sections", body));
export const listSections = (songId) => data(http.get("/song-sections", { params: { song_id: songId } }));

export const absUrl = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
export const clock = (s) => `${Math.floor((s || 0) / 60)}:${String(Math.floor((s || 0) % 60)).padStart(2, "0")}`;
export const parseClock = (v) => {
  const m = String(v).trim().match(/^(\d+)(?::(\d{1,2}(?:\.\d+)?))?$/);
  if (!m) return NaN;
  return m[2] === undefined ? Number(m[1]) : Number(m[1]) * 60 + Number(m[2]);
};
